// extracted by mini-css-extract-plugin
export var childrenContainer = "_bc-0";